import type { ComponentType } from "react";
import type { LucideProps } from "lucide-react";

type Variant = "success" | "error" | "brand";

const variantMap: Record<Variant, { bg: string; text: string }> = {
  success: { bg: "bg-green-50",     text: "text-green-600" },
  error:   { bg: "bg-red-50",       text: "text-red-600" },
  brand:   { bg: "bg-brand-pink/10", text: "text-brand-pink" },
};

type Props = {
  variant: Variant;
  icon: ComponentType<LucideProps>;
};

export const StatusIconCircle = ({ variant, icon: Icon }: Props) => {
  const { bg, text } = variantMap[variant];
  return (
    <div className={`flex items-center justify-center w-14 h-14 rounded-full mb-5 ${bg}`}>
      <Icon size={28} className={text} strokeWidth={2} />
    </div>
  );
};
